import { IAudioPlugin, IMenuItem } from "./plugin.model";
import { ITileItem, TileItem } from "./tile-item.model";

export interface IAudioProcessorTask {
  id: string;
  name: string;
  timestamp: Date;
  userId: string;
  status: IWorkerStatus;
  type: IWorkerType;
  lastUpdate: Date;
  taskBlocks: IAudioProcessorTaskBlock[];
  computingUnits: number;
  progress: number;
  plugin?: IAudioPlugin;
}


export interface IAudioProcessorTaskBlock {
  id: string;
  taskId: string;
  pluginId: string;
  plugin: IAudioPlugin;
  originalFileName: string;
  sourceUrl: string;
  destinationUrl: string;
  sampleRate: number;
  menuItems: IMenuItem[];
  numSamples: number;
  gainMatchDb: number;
  fileSize: number;
  fileDuration: number;
  status: IWorkerStatus;
  tileItem: ITileItem;
}


export enum IWorkerStatus {
  PENDING,
  RUNNING,
  DONE,
  ERROR
}

export enum IWorkerType {
  AUDIO_PROCESSOR
}

export class AudioProcessorTask implements IAudioProcessorTask {
  id!: string;
  name: string = "";
  timestamp!: Date;
  userId!: string;
  status!: IWorkerStatus;
  type!: IWorkerType;
  lastUpdate!: Date;
  taskBlocks: IAudioProcessorTaskBlock[] = [];
  progress: number = 0;
  computingUnits: number = 0;
  plugin?: IAudioPlugin

  static toServer(task: AudioProcessorTask) {
    let obj = Object.assign({}, task as any);
    delete obj.plugin;
    for (var i = 0; i < obj.taskBlocks.length; i++) {
      delete obj.taskBlocks[i].plugin;
    }

    return obj;
  }
}

export class AudioProcessorTaskBlock implements IAudioProcessorTaskBlock {
  id!: string;
  taskId!: string;
  pluginId!: string;
  originalFileName!: string;
  plugin!: IAudioPlugin;
  sourceUrl!: string;
  destinationUrl!: string;
  sampleRate!: number;
  menuItems!: IMenuItem[];
  numSamples!: number;
  gainMatchDb!: number;
  fileSize!: number;
  fileDuration!: number;
  status!: IWorkerStatus;

  tileItem: TileItem = new TileItem();
}
